module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Your Ohana phone number")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("Write this down and use it to text and call your loved one.")])]), _vm._v(" "), _c('div', {
    ref: "phone",
    staticClass: "step__you-phone"
  }, [_c('p', [_vm._v(_vm._s(_vm.ohanaNumber))])]), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button step__button--bottom"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Next")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31065267","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/2-blocks/Step7_OhanaNum.vue
// module id = 537
// module chunks = 1